module.exports = __webpack_public_path__ + "static/media/RecursosMat-ensinoInf-curto.29c8ed97.png";